<template>
    <div class="page">
        <BACK title="註冊帳號"/>
        <el-form ref="form" :model="form" :rules="rules">
            <el-form-item label="手機" prop="phone">
                <el-input type="number" oninput="value=value.replace(value.slice(10),'')" v-model="form.phone"
                          placeholder="輸入手機號碼" inputmode="decimal"></el-input>
            </el-form-item>
            <el-form-item label="真實姓名/公司行號" prop="name">
                <el-input type="text" maxlength="50" v-model="form.name"></el-input>
            </el-form-item>
            <el-form-item label="暱稱" prop="nickname">
                <el-input v-model="form.nickname" type="text" maxlength="50" clearable></el-input>
            </el-form-item>
            <el-form-item label="密碼" prop="password">
                <el-input v-model="form.password" oninput="value=value.replace(value.slice(14),'')" type="password"
                          clearable placeholder="輸入密碼"></el-input>
            </el-form-item>
            <el-form-item label="確認密碼" prop="password2">
                <el-input v-model="form.password2" oninput="value=value.replace(value.slice(14),'')" type="password"
                          clearable placeholder="再次輸入密碼"></el-input>
            </el-form-item>
            <el-form-item label="驗證碼" prop="vcode">
                <el-button class="input_btn input_note" @click="handleGetSMS" :disabled="delayTime"
                           :class="delayTime ? 'delay' : ''">
                    <template v-if="!showDelayText">
                        <i class="el-icon-loading delay" v-if="delayTime"></i>
                        <span v-else>傳送驗證碼</span>
                    </template>
                    <template v-else>
                        <span class="delay">{{delayTimeText}}</span>
                    </template>
                </el-button>
                <el-button class="input_btn input_nosms" @click="handleNoSMS">
                    <span>沒收到驗證嗎?</span>
                </el-button>
                <el-input v-model="form.vcode" ref="vcode" type="search"
                          oninput="value=value.replace(value.slice(6),'')" clearable
                          placeholder="輸入簡訊驗證碼" inputmode="decimal"></el-input>
            </el-form-item>
        </el-form>
        <div class="note normal">
            <el-checkbox v-model="note"/>
            我同意<span class="tag" @click="openTerms">《服務條款》</span>＆<span class="tag"
                                                                        @click="openPrivacy">《第三方連結免責聲明》</span>
        </div>
        <div class="btn">
            <el-button type="success" :disabled="loading" @click="beforeHandleSubmit"><i class="el-icon-loading"
                                                                                         v-if="loading"></i>註冊
            </el-button>
        </div>
        <DialogTerms :visbileName="'dialogTermsVisible'"/>
        <DialogState :visbileName="'dialogStateVisible'"/>
    </div>
</template>
<script>
    import BACK from '@/components/back'
    import FN from '@/components/fn'
    import DialogTerms from '@/components/DialogTerms'
    import DialogState from '@/components/DialogState'
    import {mapActions} from 'vuex'

    export default {
        name: 'Registered',
        components: {
            BACK,
            DialogTerms,
            DialogState
        },
        mixins: [FN],
        data() {
            return {
                dialogData: {
                    title: '',
                    content: ''
                },
                note: false,
                form: {
                    phone: '',
                    vcode: '',
                    name: '',
                    nickname: '',
                    password: '',
                    password2: '',
                }
            }
        },
        computed: {
            rules() {
                const message = '輸入不完整'
                // 自訂驗證-phone
                const isPhone = (rule, value, callback) => {
                    const length = value.length
                    if (!length) {
                        callback(new Error(message))
                    } else if (length !== 10) {
                        callback(new Error('輸入錯誤，請輸入10位元電話號碼'))
                    } else if (value.slice(0, 2) !== '09') {
                        callback(new Error('輸入錯誤，請輸入09開頭之電話號碼'))
                    } else {
                        callback()
                    }
                }
                // 自訂驗證-vcode
                const isVCode = (rule, value, callback) => {
                    const length = value.length
                    if (!length) {
                        callback(new Error(message))
                    } else if (length !== 6) {
                        callback(new Error('輸入錯誤，請輸入6位元驗證碼'))
                    } else {
                        callback()
                    }
                }
                // 自訂驗證-password
                const isPassword = (rule, value, callback) => {
                    const length = value.length
                    if (!length) {
                        callback(new Error(message))
                    } else if (length < 8 || length > 14) {
                        callback(new Error('輸入錯誤，請輸入8-14位元'))
                    } else {
                        callback()
                    }
                }
                // 自訂驗證-password2
                const isPassword2 = (rule, value, callback) => {
                    const length = value.length
                    if (!length) {
                        callback(new Error(message))
                    } else if (value !== this.form.password) {
                        callback(new Error('兩次輸入的密碼不同'))
                    } else {
                        callback()
                    }
                }
                return {
                    name: [
                        {required: true, trigger: 'blur', message},
                    ],
                    nickname: [
                        {required: true, trigger: 'blur', message}
                    ],
                    phone: [
                        {required: true, trigger: 'blur', validator: isPhone}
                    ],
                    vcode: [
                        {required: true, trigger: 'blur', validator: isVCode}
                    ],
                    password: [
                        {validator: isPassword, trigger: 'blur'},
                        {required: true, trigger: 'blur', message},
                        { type: 'string', pattern:'^[A-Za-z0-9]+$',message:'密碼限制使用英文或數字',trigger: 'blur'},
                    ],
                    password2: [
                        {validator: isPassword2, trigger: 'blur'},
                        {required: true, trigger: 'blur', message},
                        { type: 'string', pattern:'^[A-Za-z0-9]+$',message:'密碼限制使用英文或數字',trigger: 'blur'},
                    ]
                }
            },
            delayTimeText() {
                return this.delayText
            }
        },
        methods: {
            ...mapActions([
                'FETCH'
            ]),
            beforeHandleSubmit() {
                this.form.vcode = this.$refs['vcode'].value
                if (!this.delayCheck) {
                    this.$message({
                        message: '請先獲取驗證碼',
                        type: 'error'
                    });
                } else if (!this.note) {
                    this.$message({
                        message: '請同意服務條款&隱私政策',
                        type: 'error'
                    });
                } else {
                    this.handleSubmit()
                }
            },
            //送出表單
            handleSubmit() {
                const form = this.$refs.form
                this.beforeValidate()
                form.validate((valid) => {
                    if (valid) {
                        this.loading = true
                        this.beforeFormSubmit()
                        this.FETCH({
                            key: 'REGISTER',
                            name: this.form.name,
                            nickname: this.form.nickname,
                            account: this.form.phone,
                            password: this.form.password,
                            code: this.form.vcode
                        })
                            .then(this.handleResponse)
                    } else {
                        this.loading = false
                        this.handleUnValid()
                    }
                })

            },
            //獲取驗證碼
            handleGetSMS() {
                const phone = this.form.phone
                if (phone !== '' && phone.slice(0, 2) === '09' && phone.length === 10) {
                    this.delayTime = true
                    this.FETCH({
                        key: 'REGISTER_SMS',
                        phone: this.form.phone
                    }).then((res) => {
                        this.delayTime = false
                        if (!+res.data.code) {
                            this.delayCheck = this.delayCheck + 1
                            this.throttle(30)
                        } else {
                            this.throttle(5)
                        }
                        this.$message({
                            message: res.data.message,
                            type: +res.data.code ? 'error' : 'success'
                        });
                    })
                } else {
                    this.$message({
                        message: '請輸入09開頭的有效手機號碼',
                        type: 'error'
                    });
                }
            },
            //回應
            handleResponse(res) {
                if (!+res.code) {
                    //寫入註冊成功資訊
                    this.handleToken(res.data)
                    this.$confirm('註冊成功', {
                        showCancelButton: false,
                        type: 'success'
                    })
                        .then(() => {
                            const {href} = this.$router.resolve({name: 'Home'})
                            window.open(href, '_self')
                        })
                } else {
                    this.$confirm(res.message, {
                        showCancelButton: false,
                        type: 'error'
                    })
                }
                this.loading = false
            },
            handleNoSMS() {
                this.$confirm('無法取得驗證碼請稍後或立即聯絡客服', {
                    showCancelButton: false,
                    confirmButtonText: '聯絡客服',
                    type: '',
                    center: true
                })
                    .then(() => {
                        window.location.href = 'tel://07010172077'
                    })
            },
            handleBack() {
                const {href} = this.$router.resolve({name: 'Login'})
                window.open(href, '_self')
            },
        }
    }
</script>
